export enum CategoryEnum {
  InformationSecurityPolicy = 'Information Security Policy',
  AccessPolicy = 'Access Policy',
  AssetManagement = 'Asset Management',
  DeviceUsagePolicy = 'Device Usage Policy',
  PrivacyPolicy = 'Privacy Policy',
  DPOStatement = 'DPO Statement',
  DataCategory = 'Data Category',
  EnvironmentalPolicy = 'Environmental Policy',
  PaperPolicy = 'Paper Policy',
  BusinessContinuity = 'Business Continuity',
  DisasterRecovery = 'Disaster Recovery',
  Insurance = 'Insurance',
  HiringEmployees = 'Hiring Employees',
  EmployeeTermination = 'Employee Termination',
  IncidentResponse = 'Incident Response',
  AcceptableUse = 'Acceptable Use Policy',
  RemoteWork = 'Remote Work Policy',
  VendorManagement = 'Vendor Management',
  ChangeManagement = 'Change Management',
  PhysicalSecurity = 'Physical Security',
  SocialMedia = 'Social Media Policy',
  BYOD = 'Bring Your Own Device (BYOD)',
}

export enum AssetGroupEnum {
  SensitiveInfo = 'Sensitive Info',
  Hardware = 'Hardware',
  Endpoints = 'Endpoints',
  Servers = 'Servers',
  CriticalSystems = 'Critical Systems',
  MobileDevices = 'Mobile Devices',
  NetworkDevices = 'Network Devices',
  CloudResources = 'Cloud Resources',
  Applications = 'Applications',
}

export enum NetworkNatureEnum {
  Local = 'Local',
  CloudBased = 'Cloud-Based',
  Hybrid = 'Hybrid',
  VPN = 'VPN',
  // SDWAN = 'SD-WAN',
}

export enum DataScopeEnum {
  PaymentData = 'Payment Data',
  PHI = 'PHI',
  PII = 'PII',
  FinancialData = 'Financial Data',
  MilitaryData = 'Military Data',
  IntellectualProperty = 'Intellectual Property',
  CustomerData = 'Customer Data',
  EmployeeData = 'Employee Data',
  OperationalData = 'Operational Data',
}

export enum ApprovalFrequencyEnum {
  Annual = 'Annual',
  BiAnnual = 'Bi-Annual',
  Quarterly = 'Quarterly',
  Monthly = 'Monthly',
}

export enum SensitivityClassificationEnum {
  Public = 'Public',
  Internal = 'Internal',
  Confidential = 'Confidential',
  Restricted = 'Restricted',
  HighlyConfidential = 'Highly Confidential',
}
export enum optionType {
  AI = 'AI',
  Template = 'Template',
  Import = 'Import',
}
export enum frameworkType {
  RISK = 'RISK',
  COMPLIANCE = 'COMPLIANCE',
  CUSTOM = 'CUSTOM',
}
export enum summaryUserType {
  Approver = 'approver',
  Reviewer = 'reviewer',
  PolicyOwner = 'policyOwner',
}

export enum RelevantDepartmentsEnum {
  HR = 'HR',
  Compliance = 'Compliance',
  CustomerService = 'Customer Service',
  Finance = 'Finance',
  IT = 'IT',
  Legal = 'Legal',
  Marketing = 'Marketing',
  Operations = 'Operations',
  Sales = 'Sales',
  Security = 'Security',
  Support = 'Support',
}
